import type { GetTouringTreatmentForZuidAndListingWebApiResponseDto } from '@zg-rentals/ts-z-calendar-client';

type TourUpsellTreatment = Partial<
  Pick<
    GetTouringTreatmentForZuidAndListingWebApiResponseDto,
    'isTouringEligible' | 'hasAvailability' | 'hasBookedTours'
  >
>;

// The upsell nudges eligible landlords who still have nothing for renters to book: no upcoming
// availability and no booked tours. Being fully booked (hasBookedTours) suppresses it; merely
// enabling touring without adding availability does not, so isTouringEnabledForListing is not a gate.
export function isEligibleForTourUpsell(touringTreatment: TourUpsellTreatment | undefined): boolean {
  const { isTouringEligible, hasAvailability, hasBookedTours } = touringTreatment ?? {};
  return !!isTouringEligible && !hasAvailability && !hasBookedTours;
}
